import React, { useEffect, useState } from 'react';
import { Box, Button, Chip, Container, Grid, Radio, Stepper, Step, Stack, StepLabel, FormControlLabel, RadioGroup, Alert, Link, Typography } from '@mui/material';
import { ProductsPurchase } from '../Products/Products';
import { useAppDispatch, useAppSelector } from 'src/app/react/hooks/redux';
import { CreatePurchaseRequest } from 'src/app/react/models/purchase/create-purchase-request.model';
import { Auth } from 'src/app/models/auth';
import { createPurchase } from "src/app/react/redux/purchase/actions";
import { GroupsPurchase } from '../Groups/Groups';


interface CreatePurchaseProps {
    onCreatePurchase: any;
    onPurchaseCreate: (purchaseType: number, purchaseOption: number, productsId: number[]) => void;
}

export const CreatePurchase = ({ onCreatePurchase, onPurchaseCreate }: CreatePurchaseProps) => {
     
    const currentUser: Auth = JSON.parse(localStorage.getItem('currentUser'));

    const dispatch = useAppDispatch();    
    const { purchase, error, loading } = useAppSelector(state => state.purchase); 
    const { products } = useAppSelector(state => state.group); 

    const [ purchaseType, setPurchaseType ] = useState<number>(0);
    const [ purchaseOption, setPurchaseOption ] = useState<number>(1);
    const [ selectedProducts, setSelectedProducts ] = useState<number[]>([]);
    const [ selectedGroup, setSelectedGroup ] = useState<number>();

    const [ productsAndGroupsMessageError, setProductsAndGroupsMessageError ] = useState<string>(null);
    
    useEffect(() => {        
        onCreatePurchase.current = handleCreatePurchase;
        handleSelectedProducts(selectedProducts);
    }, [])

    useEffect(() => {
        onCreatePurchase.current = handleCreatePurchase;
     }, [selectedProducts, selectedGroup, purchaseOption, purchaseType])

    const handlePurchaseType = (v: number) => {
        setPurchaseType(v);
        if(v == 1){
            setPurchaseOption(2)
        }
            
        setProductsAndGroupsMessageError(null);
    }

    const handlePurchaseOption = (v: any) => {
        setPurchaseOption(parseInt(v.target.value));
    }

    const handleSelectedProducts = (selectedProducts: number[]) => {
        setSelectedProducts(selectedProducts);
        setProductsAndGroupsMessageError(null);
    }

    const handleSelectedGroup = (selectedGroup: number) => {
        setSelectedGroup(selectedGroup);
        setProductsAndGroupsMessageError(null);
    }

    const handleCreatePurchase = () => {
        setProductsAndGroupsMessageError(null);

        if(selectedProducts.length <= 0 && purchaseType === 0){
            setProductsAndGroupsMessageError("Por favor, selecione um produto!");
            return;
        }
        if(!selectedGroup && purchaseType === 1){
            setProductsAndGroupsMessageError("Por favor, selecione um grupo!");
            return;
        }

        const createPurchaseRequest: CreatePurchaseRequest = {
            purchaseOption: purchaseOption,
            productsId: purchaseType !== 1 ? selectedProducts : products,
            groupId: purchaseType === 1 ? selectedGroup : null
        }
       
        onPurchaseCreate(purchaseType, purchaseOption, selectedProducts);
        dispatch(createPurchase(currentUser.token.assignorGuid, currentUser.token.userReferenceId, createPurchaseRequest));
    }

    return (
        <Box className="p-3">
            <Typography variant="h6" className='mb-2'>Recarregar por</Typography>
            <Stack direction="row" spacing={1} className='mb-3'>
                <Chip label="Grupo Flex" color={purchaseType === 1 ? "primary": "default"} onClick={() => handlePurchaseType(1)} />
                <Chip label="Produto" color={purchaseType === 0 ? "primary": "default"} onClick={() => handlePurchaseType(0)}/>
                {/* <Chip label="Arquivo" color={purchaseType === 2 ? "primary": "default"} component={Link} href="portal/novarecarga/arquivo"/> */}
                {/* <Chip label="Arquivo" color={purchaseType === 2 ? "primary": "default"} onClick={() => handlePurchaseType(2)}/> */}
                {/* <Chip label="Cópia" color={purchaseType === 3 ? "primary": "default"} onClick={() => handlePurchaseType(3)}/> */}
            </Stack>
            <Typography variant="h6" className='mb-2'>Favorecidos</Typography>
                <RadioGroup row aria-labelledby="collaborators-radio-buttons-group-label" name="collaborators-radio-buttons-group" value={purchaseOption} onChange={handlePurchaseOption}>
                    <Grid container spacing={1} columns={{ xs: 4, sm: 8, md: 12 }}>
                        { purchaseType === 0 &&
                            <Grid item xs={12} sm={12} md={2} key='purchaseOpt1'>
                                <FormControlLabel value="1" control={<Radio />} label="Todos" />
                            </Grid>
                        }
                        {/* { (purchaseType === 0 || purchaseType === 1) &&
                            <Grid item md={6} sm={12}>
                                <FormControlLabel value="2" control={<Radio />} label="Todos colaboradores com os seguintes produtos" />
                            </Grid>
                        } */}
                        {/* { purchaseType === 0 &&
                            <Grid item md={4} sm={12}>
                                <FormControlLabel value="3" control={<Radio />} label="Alguns colaboradores e respectivos produtos" />
                            </Grid>
                        } */}
                        { (purchaseType === 0 || purchaseType === 1) &&
                            <Grid item xs={12} sm={12} md={2} key='purchaseOpt4'>
                                <FormControlLabel value="4" control={<Radio />} label="Seleção de Alguns" />
                            </Grid>
                        }
                        { (purchaseType === 0 || purchaseType === 1) &&
                            <Grid item xs={12} sm={12} md={2} key='purchaseOptFile'>
                                <FormControlLabel value="5" control={<Radio />} label="Contidos em um Arquivo" />
                            </Grid>
                        }
                    </Grid>
                </RadioGroup>
            <Grid container>
                { productsAndGroupsMessageError &&
                    <Alert sx={{width: '100%'}} className='mb-2' severity="warning">{productsAndGroupsMessageError}</Alert>
                }
                { (purchaseType === 0) &&
                    <ProductsPurchase selectedProducts={handleSelectedProducts} key="ProductPurchase"/>
                }
                { (purchaseType === 1) &&
                    <GroupsPurchase selectedGroup={handleSelectedGroup} key="GroupsPurchase"/>
                }
            </Grid>
        </Box>
    );
}
